import Decimal from "decimal.js";

const MULTA_FIXA = 6.4;
const JUROS_DIA = 0.19;

export const SituacaoParcela = {
  0: "Em aberto",
  1: "Paga",
  2: "Negociada",
};

export default class Parcela {
  constructor(parcela) {
    const { descontoAplicavel, valorEmAberto, ...dados } = parcela;
    Object.assign(this, dados);
    this._verificando = false;
    if (descontoAplicavel !== undefined) {
      this._descontoAplicavelBackend = descontoAplicavel;
    }
  }

  get verificando() {
    return this._verificando;
  }

  set verificando(value) {
    this._verificando = value;
  }

  get valorPago() {
    return this.valorpago;
  }

  get ehTaxa() {
    return this.tipo === "TAXA";
  }

  get descontoAplicavel() {
    if (this.ehTaxa) return 0;
    if (this._descontoAplicavelBackend !== undefined) return this._descontoAplicavelBackend;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const descontosValidos = [];

    const faixas = [
      { valor: this.matricula?.desconto_1 || this.desconto_1 || 0, data: this.referencia_1 },
      { valor: this.matricula?.desconto_2 || this.desconto_2 || 0, data: this.referencia_2 },
      { valor: this.matricula?.desconto_3 || this.desconto_3 || 0, data: this.referencia_3 },
    ];

    faixas.forEach((faixa) => {
      if (faixa.valor > 0 && faixa.data) {
        const dataLimite = new Date(`${faixa.data}T23:59:59`);
        if (hoje <= dataLimite) {
          descontosValidos.push(faixa.valor);
        }
      }
    });

    return descontosValidos.length > 0 ? Math.max(...descontosValidos) : 0;
  }

  get descontosTiers() {
    if (this.ehTaxa) return [];

    const faixas = [
      { valor: this.matricula?.desconto_1 || this.desconto_1 || 0, data: this.referencia_1 },
      { valor: this.matricula?.desconto_2 || this.desconto_2 || 0, data: this.referencia_2 },
      { valor: this.matricula?.desconto_3 || this.desconto_3 || 0, data: this.referencia_3 },
    ];
    return faixas.filter((f) => f.valor > 0 && f.data);
  }

  get diasAtraso() {
    if (!this.estaAtrasada) return 0;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const venc = new Date(`${this.referencia_3}T00:00:00`);
    return Math.floor((hoje - venc) / (1000 * 60 * 60 * 24));
  }

  get multaCalculada() {
    if (this.multa > 0) return this.multa;
    return this.estaAtrasada ? MULTA_FIXA : 0;
  }

  get jurosCalculados() {
    if (this.juros > 0) return this.juros;
    return this.estaAtrasada ? new Decimal(JUROS_DIA).times(this.diasAtraso).toNumber() : 0;
  }

  get valorEmAberto() {
    return new Decimal(this.valor || 0)
      .plus(this.multaCalculada)
      .plus(this.jurosCalculados)
      .minus(this.valorPago || 0)
      .minus(this.descontoAplicavel || 0)
      .toFixed(2);
  }

  get estaEmAberto() {
    return this.situacao === 0;
  }

  get estaPaga() {
    return this.situacao === 1;
  }

  get estaNegociada() {
    return this.situacao === 2;
  }

  get situacaoEmExtenso() {
    try {
      const situacaoEmExtenso = SituacaoParcela[this.situacao];
      return situacaoEmExtenso;
    } catch (error) {
      return "Situação desconhecida";
    }
  }

  get estaAtrasada() {
    if (this.situacao !== 0) return false;
    if (!this.referencia_3) return false;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const referencia = new Date(this.referencia_3);
    return referencia < hoje;
  }

  get temDesconto() {
    return this.descontoAplicavel > 0;
  }

  get mesAnoReferencia() {
    if (!this.referencia_3) return "";
    const meses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    const partes = this.referencia_3.split("-");
    const ano = partes[0];
    const mes = parseInt(partes[1], 10) - 1;
    return `${meses[mes]} de ${ano}`;
  }

  get descricaoMensalidade() {
    if (this.descricao) return this.descricao;

    const partes = ["Mensalidade"];
    if (this.turma?.curso?.descricao) partes.push(this.turma.curso.descricao);
    if (this.turma?.descricao) partes.push(this.turma.descricao);
    return partes.join(" - ");
  }
}
